import { type ReactNode } from 'react';
import { Avatar } from '@/components/ui/avatar';
import { ExternalLink } from 'lucide-react';
import type { Creator } from '@/types';
import { creatorPhotoUrl } from '../utils/creator-formatters';

function IgLink({ username }: { username: string }): ReactNode {
  return (
    <a
      href={`https://instagram.com/${username}`}
      target="_blank"
      rel="noopener noreferrer"
      className="text-text-tertiary hover:text-brand-red"
    >
      <ExternalLink size={12} />
    </a>
  );
}

function ProfileAvatarLink({ creator }: { creator: Creator }): ReactNode {
  return (
    <a
      href={`https://instagram.com/${creator.ig_username}`}
      target="_blank"
      rel="noopener noreferrer"
      title="Ver perfil de Instagram en una pestaña nueva"
      className="shrink-0 cursor-pointer"
    >
      <Avatar
        src={creatorPhotoUrl(creator)}
        name={creator.ig_username}
        size="lg"
      />
    </a>
  );
}

export function CreatorProfile({ creator }: { creator: Creator }): ReactNode {
  return (
    <div className="flex items-start gap-md">
      <ProfileAvatarLink creator={creator} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-xs">
          <p className="text-sm font-medium text-text-primary">
            @{creator.ig_username}
          </p>
          <IgLink username={creator.ig_username} />
        </div>
        <p className="text-xs text-text-tertiary">{creator.display_name}</p>
        {creator.bio && (
          <p className="mt-sm text-xs leading-relaxed text-text-secondary">
            {creator.bio}
          </p>
        )}
      </div>
    </div>
  );
}
